import { useQuery } from '@tanstack/react-query';

import { KPI_TERRITORY, KPI_VEHICLE_GEOLOCATION } from '../constants.ts';
import { getStatistics } from '../queries/getStatistics.ts';
import { MissionHistory } from '../schema/Mission.ts';
import { Statistics } from '../schema/Statistiques.ts';
import { getIsoFormatDatetime } from '../utils/utils.ts';

export const useLiveStatistics = (territorySlug: string) => {
  const params: Statistics = {
    start_date: getIsoFormatDatetime(6, true),
    end_date: getIsoFormatDatetime(20, false),
    metrics: KPI_TERRITORY,
  };
  return useQuery({
    queryKey: ['liveStatistics', territorySlug],
    queryFn: ({ signal }) => getStatistics(territorySlug, params, signal),
    retry: false,
    throwOnError: true,
  });
};

export const useVehicleGeolocation = (
  territorySlug: string,
  vehicleId: number | undefined,
  history: MissionHistory | undefined,
) => {
  let params = {};
  const lifecycles = history?.lifecycles;
  if (lifecycles !== undefined) {
    const youngestLifecycle = lifecycles?.[0].updated_at;
    const oldestLifecycle = lifecycles?.at(-1)?.updated_at;
    params = {
      start_date: oldestLifecycle,
      end_date: youngestLifecycle,
      metrics: KPI_VEHICLE_GEOLOCATION,
      vehicle_id: String(vehicleId),
    };
  }
  return useQuery({
    queryKey: ['geolocations', territorySlug, vehicleId, history?.id],
    queryFn: ({ signal }) => getStatistics(territorySlug, params, signal),
    enabled: vehicleId !== undefined && history?.lifecycles !== undefined,
    retry: false,
  });
};
